import { Dispatch } from "redux";

export const storeConnector: { dispatch: Dispatch<any> | null } = { dispatch: null };
